import React, { useState, useEffect } from 'react';
import Cookies from "cookies-js"
import { styled } from "../../../stitches.config";
import Box from '../Box'

export default props => {
    const [voted, setVoted] = useState(null)
    const [hasCookie, setHasCookie] = useState(false)

    useEffect(() => {
        const value = Cookies.get("_brid");
        if (typeof value === "string") {
            const [blockID, articleID] = value.split(".");
            setHasCookie(true)
            if (blockID === props.uID) {
                setVoted(articleID)
            }
        }
    }, [])

    return (
        <section className="container">
            <FirstLine />
            <div className="row" style={{ position: 'relative' }}>
                <Box {...props}
                    id="b1"
                    type="BridUniversalCompare"
                    settings={props.settings.b1}
                    preserveImageRatio={true}
                    classes=""
                    secondArticleID={props.settings.b2?.articleID}
                    thirdArticleID={props.settings.b3?.articleID}
                    voted={voted}
                    setVoted={setVoted}
                    uID={props.settings.uID}
                    hasCookie={hasCookie}
                />
            </div>
            <Line />
            <div className="row" style={{ position: 'relative' }}>
                <Box {...props}
                    id="b2"
                    type="BridUniversalCompare"
                    settings={props.settings.b2}
                    preserveImageRatio={true}
                    classes=""
                    secondArticleID={props.settings.b1?.articleID}
                    thirdArticleID={props.settings.b3?.articleID}
                    voted={voted}
                    setVoted={setVoted}
                    uID={props.settings.uID}
                    hasCookie={hasCookie}
                />
            </div>
            <Line />
            <div className="row" style={{ position: 'relative' }}>
                <Box {...props}
                    id="b3"
                    type="BridUniversalCompare"
                    settings={props.settings.b3}
                    preserveImageRatio={true}
                    classes=""
                    secondArticleID={props.settings.b1?.articleID}
                    thirdArticleID={props.settings.b2?.articleID}
                    voted={voted}
                    setVoted={setVoted}
                    uID={props.settings.uID}
                    hasCookie={hasCookie}
                />
            </div>
        </section>
    );
}

const Line = styled("div", {
    backgroundColor: "$grayscale25",
    margin: "0 0 24px 0",
    height: "1px",
    width: "100%",
});

const FirstLine = styled("div", {
    height: "0px",
    width: "100%",
    "@bp4": {
        margin: "24px 0 0 0",
    }
});